import React, { useState, useEffect, useContext } from "react";

import * as Sentry from "@sentry/react";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import Typography from "@material-ui/core/Typography";

import { Grid, Box, Link, Backdrop, CircularProgress } from "@material-ui/core";
import { useDispatch } from "react-redux";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Hidden from "@material-ui/core/Hidden";

import { useHistory } from "react-router-dom";

import DropInput from "../../components/DropInput";

import ReactVideoRec from "../../components/ReactVideoRec";
// import qrcode from '../../assets/img/qrcode.png';

import { CoinContext } from "../../contexts/CoinContext";
import { REACT_APP_PROD_URL } from "../../services/configs";
import Milestones from "../../components/Milestones";
import loaderGif from "../../assets/img/loader.gif";
import { useSelector } from "react-redux";
import fetcher from "../../api/swr_fetcher";
import Backicon from "../../assets/icons/backicon";

// const ColorButton = withStyles((theme) => ({
//   root: {
//     color: "white",
//     backgroundColor: "#E65661",
//     "&:hover": {
//       backgroundColor: "#9b1722",
//     },
//     fontWeight: "bold",
//     minWidth: "30%",
//   },
// }))(Button);

export default function Onboarding() {
  const classes = useStyles();
  const theme = useTheme();
  let history = useHistory();

  const token = useSelector((state) => state.trading.TOKEN);

  const [cardType, setCardType] = useState("aadhar card");
  const [step, setStep] = useState(0);

  const [phoneNum, setPhoneNum] = useState("");
  const [phoneVerify, setPhoneVerify] = useState(false);
  const [phoneOtp, setPhoneOtp] = useState(null);
  // const [isPhoneValid, setIsPhoneValid] = useState(true);
  const dispatch = useDispatch();
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [streetAddress1, setStreetAddress1] = useState(null);
  const [streetAddress2, setStreetAddress2] = useState(null);
  const [city, setCity] = useState(null);
  const [state, setState] = useState(null);
  const [zipcode, setZipcode] = useState(null);
  const [panNum, setPanNum] = useState(null);
  const [panFront, setPanFront] = useState(null);

  const [secondaryNum, setSecondaryNum] = useState(null);
  const [secondaryFront, setSecondaryFront] = useState(null);
  const [secondaryBack, setSecondaryBack] = useState(null);
  // const [videoOtp, setVideoOtp] = useState(null);
  // const [video, setVideo] = useState(null);
  const [kycDetails, setKycDetails] = useState({
    stepOneComplete: false,
    stepTwoComplete: false,
    stepThreeComplete: false,
    stepFourComplete: false,
  });

  const [isBasicInfoValid, setIsBasicInfoValid] = useState(true);

  const [showMilestone, setShowMilestone] = useState(false);

  const [doubleClick, setDoubleClick] = useState(false);

  const [errorFields, setErrorFields] = useState({
    phonenum: false,
    otp: false,
    firstname: false,
    lastname: false,
    st1: false,
    st2: false,
    city: false,
    state: false,
    zip: false,
    panno: false,
    pancard: false,
    secno: false,
    seccardf: false,
    seccardb: false,
  });

  const { handleClickAlert } = useContext(CoinContext);

  const [counter, setCounter] = useState(120);
  const [startTimer, setStartTimer] = useState(false);

  useEffect(() => {
    if (token) {
      fetcher(`/v1/um/getKycDetails`)
        .then((data) => {
          setKycDetails(data);
          if (!data.stepFourComplete) {
            window?.ReactNativeWebView?.postMessage(
              JSON.stringify({ kyc: false })
            );
          }
          // console.log(data);
          if (data.phonenumber) {
            if (data.stepOneComplete) {
              setStep(2);
            } else {
              setStep(1);
            }
          }
          setShowMilestone(true);
        })
        .catch((err) => {
          console.error(err);
          window?.ReactNativeWebView?.postMessage(
            JSON.stringify({ kyc: false })
          );
          // console.error(err);
          setShowMilestone(true);
        });

      // console.log("Getting kyc details");
    }
  }, [step]);

  function onPhoneNumSubmit() {
    if (token && phoneNum.length === 10) {
      if (phoneVerify) {
        if (phoneOtp) {
          fetcher(`/v1/um/addPhone`, {
            method: "POST",
            body: {
              countryCode: "+91",
              phonenumber: phoneNum,
              otp: phoneOtp,
            },
          })
            .then((res) => {
              setStep(1);
              // setIsPhoneValid(true);
              setErrorFields({
                ...errorFields,
                phonenum: false,
                otp: false,
              });
              handleClickAlert("success", "Phone number verified successfully");
              setDoubleClick(false);

              // console.log(res);
            })
            .catch((err) => {
              setPhoneVerify(false);
              setPhoneOtp(null);
              handleClickAlert("error", "Phone number verification failed");
              setDoubleClick(false);
              console.error(err);
              // console.error(err);
            });
        } else {
          setErrorFields({
            ...errorFields,
            phonenum: phoneNum ? false : true,
            otp: phoneOtp ? false : true,
          });
          setDoubleClick(false);
        }
      } else {
        fetcher(`/v1/um/sendPhoneOtp?countryCode=+91&phonenumber=${phoneNum}`)
          .then((res) => {
            setStartTimer(true);
            handleClickAlert("info", "OTP sent");
            setPhoneVerify(true);
            setErrorFields({
              ...errorFields,
              phonenum: false,
            });
            setDoubleClick(false);
          })
          .catch((err) => {
            if (err.status === 409) {
              handleClickAlert(
                "error",
                "This phone number is associated with an existing account. Please try with a different number."
              );
              setDoubleClick(false);
            } else {
              handleClickAlert("error", "Sending OTP failed");
              setDoubleClick(false);
            }
            console.error(err);
            // console.error(err);
          });

        // console.log("Sending phone number otp");
      }
    } else {
      // setIsPhoneValid(false);
      setErrorFields({
        ...errorFields,
        phonenum: phoneNum ? false : true,
      });
      handleClickAlert(
        "error",
        "Please make sure you've entered a valid number"
      );
      setDoubleClick(false);
    }
  }

  function resendOtp() {
    if (token && phoneNum.length === 10) {
      setStartTimer(true);
      fetcher(`/v1/um/resendPhoneOtp?countryCode=+91&phonenumber=${phoneNum}`)
        .then((res) => {
          handleClickAlert("success", "OTP resent");

          // console.log(res);
        })
        .catch((err) => {
          handleClickAlert("error", "OTP resend failed");
          console.error(err);
          // console.error(err);
        });
    } else {
      handleClickAlert("error", "Please enter correct phone number");
    }
  }

  function onBasicInfoSubmit() {
    if (
      token &&
      firstName &&
      lastName &&
      streetAddress1 &&
      // streetAddress2 &&
      city &&
      state &&
      zipcode
    ) {
      fetcher(`/v1/um/kyc-step-1`, {
        method: "POST",
        body: {
          firstName: firstName,
          lastName: lastName,
          streetAddress: streetAddress1,
          streetAddress_2: "",
          city: city,
          state: state,
          postalCode: zipcode,
          country: "india",
        },
      })
        .then((res) => {
          // on successful submission
          setStep(2);
          setErrorFields({
            ...errorFields,
            firstname: false,
            lastname: false,
            st1: false,
            // st2: false,
            city: false,
            state: false,
            zip: false,
          });
          handleClickAlert("success", "Submission successful");
          setDoubleClick(false);

          // console.log(res);
        })
        .catch((err) => {
          setErrorFields({
            ...errorFields,
            firstname: false,
            lastname: false,
            st1: false,
            // st2: false,
            city: false,
            state: false,
            zip: false,
          });
          handleClickAlert("error", "Submission failed, please try again");
          setDoubleClick(false);
          console.error(err);
          // console.error(err);
        });

      // console.log("Submitting basic info");
    } else {
      setIsBasicInfoValid(false);
      setErrorFields({
        ...errorFields,
        firstname: firstName ? false : true,
        lastname: lastName ? false : true,
        st1: streetAddress1 ? false : true,
        // st2: streetAddress2 ? false : true,
        city: city ? false : true,
        state: state ? false : true,
        zip: zipcode ? false : true,
      });
      setDoubleClick(false);
    }
  }

  function onPanSubmit() {
    if (token && panNum && panFront) {
      let formData = new FormData();
      formData.append("documentNumber", panNum);
      formData.append("front", panFront);

      fetcher(`/v1/um/kyc-step-2`, {
        method: "POST",
        body: formData,
        type: "formData",
      })
        .then((res) => {
          // on successful submission
          setStep(3);
          setErrorFields({
            ...errorFields,
            panno: false,
            pancard: false,
          });
          handleClickAlert("success", "Submission successful");
          setDoubleClick(false);

          // console.log(res);
        })
        .catch((err) => {
          setErrorFields({
            ...errorFields,
            panno: false,
            pancard: false,
          });
          setDoubleClick(false);
          if (err.status === 400) {
            handleClickAlert("error", "This PAN number already exists");
          } else {
            handleClickAlert("error", "Request failed, please try again");
          }
          console.error(err);
          // console.log(err.response.request._response);
        });

      // console.log("Submitting PAN info");
    } else {
      // setIsPanValid(false);
      setErrorFields({
        ...errorFields,
        panno: panNum ? false : true,
        pancard: panFront ? false : true,
      });
      setDoubleClick(false);
    }
  }

  async function submitPANnum() {
    if (token && panNum) {
      let fileBlob = await fetch(kycDetails.frontDocumentPrimary)
        .then((r) => r.blob())
        .then(
          (blobFile) =>
            new File([blobFile], "frontPrimary", { type: "image/png" })
        );

      // console.log(fileBlob)

      var formData = new FormData();
      formData.append("documentNumber", panNum);
      formData.append("front", fileBlob);

      fetcher(`/v1/um/kyc-step-2`, {
        method: "POST",
        body: formData,
        type: "formData",
      })
        .then((res) => {
          // on successful submission
          setStep(3);
          setErrorFields({
            ...errorFields,
            panno: false,
          });
          handleClickAlert("success", "Submission successful");
          setDoubleClick(false);

          // console.log(res);
        })
        .catch((err) => {
          setErrorFields({
            ...errorFields,
            panno: false,
          });
          setDoubleClick(false);
          if (err.status === 400) {
            handleClickAlert("error", "This PAN number already exists");
          } else {
            handleClickAlert("error", "Request failed, please try again");
          }
          console.error(err);
          // console.log(err.response.request._response);
        });

      // console.log("Submitting PAN info");
    } else {
      // setIsPanValid(false);
      setErrorFields({
        ...errorFields,
        panno: panNum ? false : true,
      });
      setDoubleClick(false);
    }
  }

  function onSecondaryDocSubmit() {
    if (token && secondaryNum && secondaryFront && secondaryBack) {
      var formData = new FormData();
      formData.append("documentNumber", secondaryNum);
      formData.append("front", secondaryFront);
      formData.append("back", secondaryBack);

      fetcher(`/v1/um/kyc-step-3`, {
        method: "POST",
        body: formData,
        type: "formData",
      })
        .then((res) => {
          setStep(4);

          setErrorFields({
            ...errorFields,
            secno: false,
            seccardf: false,
            seccardb: false,
          });
          handleClickAlert("success", "Submission successful");
          setDoubleClick(false);

          // console.log(res);
        })
        .catch((err) => {
          setErrorFields({
            ...errorFields,
            secno: false,
            seccardf: false,
            seccardb: false,
          });
          handleClickAlert("error", "Request failed, please try again");
          setDoubleClick(false);
          console.error(err);
          // console.error(err);
        });

      // console.log("Submitting secondary doc info");
    } else {
      // setIsSecondDocValid(false);
      setErrorFields({
        ...errorFields,
        secno: secondaryNum ? false : true,
        seccardf: secondaryFront ? false : true,
        seccardb: secondaryBack ? false : true,
      });
      setDoubleClick(false);
    }
  }

  // function getVideoOtp(){
  //   if(token){
  //     var bearer = 'Bearer ' + token
  //     fetch(REACT_APP_PROD_URL+`/v1/um/getKycOtp`, {
  //         method: "GET",
  //         withCredentials: true,
  //         credentials: 'include',
  //         headers: {"Authorization": bearer},
  //     })
  //       .then((res) => res.json())
  //       .then((data) =>  {
  //         setVideoOtp(data.otp)
  //         console.log(data)
  //       })
  //       .catch((err) => console.error(err))
  //   }
  // }

  // function sendVideo(){
  //   if(token){
  //     var formData = new FormData();
  //     formData.append("video", video);
  //
  //     var bearer = 'Bearer ' + token
  //     fetch(REACT_APP_PROD_URL+`/v1/um/kyc-step-4`, {
  //         method: "POST",
  //         withCredentials: true,
  //         credentials: 'include',
  //         headers: {"Authorization": bearer},
  //         body: formData,
  //     })
  //       .then((res) => {
  //         if(res.status === 200){
  //           console.log('success')
  //           setStep(5)
  //         }
  //         console.log(res)
  //       })
  //       .catch((err) => console.log(err.response.request._response))
  //
  //     console.log("Submitting video selfie")
  //   }
  // }

  function sendSMS() {
    if (kycDetails.phonenumber) {
      fetcher(`/v1/um/smsLink`, {
        method: "POST",
        body: {
          link: `https://bit.ly/3i7YwDB`,
        },
      })
        .then((res) => {
          // console.log("SMS with link sent");
          handleClickAlert("info", "SMS with link sent");
          setDoubleClick(false);

          // console.log(res);
        })
        .catch((err) => {
          handleClickAlert("error", "Failed to send the SMS, please try again");
          setDoubleClick(false);
        });
    }
  }

  const padTime = (time) => {
    return String(time).length === 1 ? `0${time}` : `${time}`;
  };

  const format = (time) => {
    // Convert seconds into minutes and take the whole part
    const minutes = Math.floor(time / 60);

    // Get the seconds left after converting minutes
    const seconds = time % 60;

    //Return combined values as string in format mm:ss
    return `${minutes}:${padTime(seconds)}`;
  };

  useEffect(() => {
    let timer;
    if (counter > 0 && startTimer) {
      timer = setTimeout(() => setCounter((c) => c - 1), 1000);
    } else if (counter === 0) {
      setStartTimer(false);
      setCounter(120);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [counter, startTimer]);

  return (
    <div className={classes.root}>
      <div>
        <Button
          onClick={() => {
            dispatch({ type: "SET_ACC_POPUP", payload: true });
          }}
          disableRipple
          className="bg-transparent md:hidden  min-w-max p-0 mt-[-30px]   w-[30px] h-[30px]"
        >
          <Backicon />
        </Button>
      </div>
      <p className={classes.topHeading}>Setting up your account</p>

      <Grid container className={classes.paddedContainer}>
        {kycDetails.status === "rejected" ? (
          <p
            style={{
              fontSize: "1rem",
              marginBottom: "50px",
              background: theme.palette.type === "dark" ? "#581f1f" : "#fed9d9",
              // width: "115px",
              fontWeight: "bold",
              color: theme.palette.type === "dark" ? "#fed9d9" : "#ff5f5f",
            }}
          >
            Your KYC details are {kycDetails.status}.{" "}
            {kycDetails.rejectionComment}.
          </p>
        ) : null}

        {showMilestone ? (
          <Milestones
            stepsCompleted={{
              one: kycDetails.stepOneComplete,
              two: kycDetails.stepTwoComplete,
              three: kycDetails.stepThreeComplete,
              four: kycDetails.stepFourComplete,
              status: kycDetails.status,
            }}
          />
        ) : null}

        <Hidden smDown>
          {kycDetails.phonenumber ? (
            kycDetails.stepOneComplete &&
            kycDetails.stepTwoComplete &&
            kycDetails.stepThreeComplete &&
            kycDetails.stepFourComplete ? null : (
              <Grid container justify="flex-end">
                <Grid item>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Typography
                      variant="body1"
                      component="p"
                      gutterBottom
                      className={classes.stepSubHeading}
                    >
                      Continue filling this form on Mobile?
                    </Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ color: "white", fontWeight: "bold" }}
                      onClick={() => {
                        setDoubleClick(true);
                        sendSMS();
                      }}
                    >
                      Get the link in SMS
                    </Button>
                  </div>
                </Grid>
              </Grid>
            )
          ) : null}
        </Hidden>

        {/*Phone number Verification - step 0*/}
        <Grid item xs={12} style={{ marginBottom: "75px" }}>
          {kycDetails.phonenumber ? (
            <div style={{ pointerEvents: "none", opacity: "0.4" }}>
              <Box>
                <Typography className={classes.stepHeading}>
                  Phone Number Verification
                </Typography>
                <Typography
                  variant="body1"
                  component="p"
                  gutterBottom
                  className={classes.stepSubHeading}
                >
                  Verify your phone number to enter basic info
                </Typography>
              </Box>
              <Box display="flex" justifyContent="space-between">
                <Typography
                  variant="body1"
                  component="p"
                  className={classes.fieldLabel}
                >
                  Phone Number
                </Typography>
              </Box>
              <Box>
                <TextField
                  fullWidth={true}
                  name="phoneNumber"
                  required
                  className={classes.textFieldRoot}
                  InputProps={{
                    classes: { root: classes.textFieldStyles },
                  }}
                  variant="outlined"
                  value={kycDetails.phonenumber}
                />
              </Box>
            </div>
          ) : (
            <div
              style={{
                pointerEvents: step > 0 ? "none" : null,
                opacity: step > 0 ? "0.4" : null,
              }}
            >
              <Box>
                <Typography className={classes.stepHeading}>
                  Phone Number Verification
                </Typography>
                <Typography
                  variant="body1"
                  component="p"
                  gutterBottom
                  className={classes.stepSubHeading}
                >
                  Verify your phone number to enter basic info
                </Typography>
              </Box>
              <Box display="flex" justifyContent="space-between">
                <Typography
                  variant="body1"
                  component="p"
                  className={classes.fieldLabel}
                >
                  Phone Number
                </Typography>
              </Box>
              <Box>
                <TextField
                  fullWidth={true}
                  name="phoneNumber"
                  required
                  className={classes.textFieldRoot}
                  InputProps={{
                    classes: { root: classes.textFieldStyles },
                    inputProps: { maxLength: 10 },
                  }}
                  variant="outlined"
                  onChange={(e) => {
                    let val = e.target.value.replace(/[^0-9]$/, "");
                    setPhoneNum(val);
                  }}
                  value={phoneNum}
                  error={errorFields.phonenum}
                  helperText={
                    errorFields.phonenum ? "Please enter phone number" : null
                  }
                />
              </Box>
              {phoneVerify ? (
                <>
                  <Box display="flex" justifyContent="space-between">
                    <Typography
                      variant="body1"
                      component="p"
                      className={classes.fieldLabel}
                    >
                      OTP
                    </Typography>
                  </Box>
                  <Box>
                    <TextField
                      fullWidth={true}
                      name="emailotp"
                      required
                      className={classes.textFieldRoot}
                      InputProps={{
                        classes: { root: classes.textFieldStyles },
                      }}
                      variant="outlined"
                      type="number"
                      onChange={(e) => setPhoneOtp(e.target.value)}
                      error={errorFields.otp}
                      helperText={
                        errorFields.otp ? "Please enter the otp" : null
                      }
                    />
                  </Box>
                </>
              ) : null}
              {/* {isPhoneValid ? null : (
                <p style={{ color: "red", margin: 0 }}>
                  Please enter correct phone number
                </p>
              )} */}
              <div style={{ textAlign: "right" }}>
                {phoneVerify ? (
                  counter === 0 || counter === 120 ? (
                    <p onClick={resendOtp} className={classes.link}>
                      Resend OTP
                    </p>
                  ) : (
                    <p>Resend OTP in {format(counter)}</p>
                  )
                ) : null}
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={() => {
                    setDoubleClick(true);
                    onPhoneNumSubmit();
                  }}
                  disabled={doubleClick}
                >
                  {phoneVerify ? "Verify" : "Get OTP"}
                </Button>
              </div>
            </div>
          )}
        </Grid>

        <Grid item xs={12}>
          {/*Basic Info - step 1*/}
          {kycDetails.stepOneComplete ? (
            <div style={{ pointerEvents: "none", opacity: "0.4" }}>
              <Grid
                container
                justify="space-between"
                direction="row"
                // style={{ marginBottom: "25px" }}
              >
                <Box>
                  <Typography className={classes.stepHeading}>
                    Basic Info
                  </Typography>
                  <Typography
                    variant="body1"
                    component="p"
                    gutterBottom
                    className={classes.stepSubHeading}
                  >
                    Enter your details below
                  </Typography>
                </Box>
                {/* <Box>
                  <DropInput label="Edit" />
                </Box> */}
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Box display="flex" justifyContent="space-between">
                    <Typography
                      variant="body1"
                      component="p"
                      className={classes.fieldLabel}
                    >
                      FIRST NAME
                    </Typography>
                  </Box>
                  <Box>
                    <TextField
                      fullWidth={true}
                      className={classes.textFieldRoot}
                      InputProps={{
                        classes: { root: classes.textFieldStyles },
                      }}
                      variant="outlined"
                      value={kycDetails.firstName ? kycDetails.firstName : ""}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box display="flex" justifyContent="space-between">
                    <Typography
                      variant="body1"
                      component="p"
                      className={classes.fieldLabel}
                    >
                      LAST NAME
                    </Typography>
                  </Box>
                  <Box>
                    <TextField
                      fullWidth={true}
                      className={classes.textFieldRoot}
                      InputProps={{
                        classes: { root: classes.textFieldStyles },
                      }}
                      variant="outlined"
                      value={kycDetails.lastName ? kycDetails.lastName : ""}
                    />
                  </Box>
                </Grid>
              </Grid>
              <Box display="flex" justifyContent="space-between">
                <Typography
                  variant="body1"
                  component="p"
                  className={classes.fieldLabel}
                >
                  Email ID
                </Typography>
              </Box>
              <Box>
                <TextField
                  fullWidth={true}
                  name="email"
                  className={classes.textFieldRoot}
                  InputProps={{
                    classes: { root: classes.textFieldStyles },
                  }}
                  variant="outlined"
                  value={kycDetails.email}
                />
              </Box>

              {/*Address part*/}
              <Box display="flex" justifyContent="space-between">
                <Typography
                  variant="body1"
                  component="p"
                  className={classes.fieldLabel}
                >
                  STREET LINE 1
                </Typography>
              </Box>
              <Box>
                <TextField
                  fullWidth={true}
                  name="street1"
                  required
                  className={classes.textFieldRoot}
                  InputProps={{
                    classes: { root: classes.textFieldStyles },
                  }}
                  variant="outlined"
                  value={
                    kycDetails.streetAddress ? kycDetails.streetAddress : ""
                  }
                />
              </Box>

              <Box display="flex" justifyContent="space-between">
                <Typography
                  variant="body1"
                  component="p"
                  className={classes.fieldLabel}
                >
                  STREET LINE 2
                </Typography>
              </Box>
              <Box>
                <TextField
                  fullWidth={true}
                  name="street2"
                  required
                  className={classes.textFieldRoot}
                  InputProps={{
                    classes: { root: classes.textFieldStyles },
                  }}
                  variant="outlined"
                  value={
                    kycDetails.streetAddress_2 ? kycDetails.streetAddress_2 : ""
                  }
                />
              </Box>
              <Box display="flex" justifyContent="space-between">
                <Typography
                  variant="body1"
                  component="p"
                  className={classes.fieldLabel}
                >
                  CITY
                </Typography>
              </Box>
              <Box>
                <TextField
                  fullWidth={true}
                  name="city"
                  required
                  className={classes.textFieldRoot}
                  InputProps={{
                    classes: { root: classes.textFieldStyles },
                  }}
                  variant="outlined"
                  value={kycDetails.city ? kycDetails.city : ""}
                />
              </Box>

              <Box>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="body1"
                        component="p"
                        className={classes.fieldLabel}
                      >
                        STATE
                      </Typography>
                    </Box>
                    <Box>
                      <TextField
                        fullWidth={true}
                        name="state"
                        required
                        className={classes.textFieldRoot}
                        InputProps={{
                          classes: { root: classes.textFieldStyles },
                        }}
                        variant="outlined"
                        value={kycDetails.state ? kycDetails.state : ""}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={6}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="body1"
                        component="p"
                        className={classes.fieldLabel}
                      >
                        ZIPCODE
                      </Typography>
                    </Box>
                    <Box>
                      <TextField
                        fullWidth={true}
                        name="zip"
                        required
                        className={classes.textFieldRoot}
                        InputProps={{
                          classes: { root: classes.textFieldStyles },
                        }}
                        variant="outlined"
                        value={
                          kycDetails.postalCode ? kycDetails.postalCode : ""
                        }
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </div>
          ) : (
            <div
              style={{
                pointerEvents: step < 1 ? "none" : null,
                opacity: step < 1 ? "0.4" : null,
              }}
            >
              <Grid
                container
                justify="space-between"
                direction="row"
                // style={{ marginBottom: "25px" }}
              >
                <Box>
                  <Typography className={classes.stepHeading}>
                    Basic Info
                  </Typography>
                  <Typography
                    variant="body1"
                    component="p"
                    gutterBottom
                    className={classes.stepSubHeading}
                  >
                    Enter your details below
                  </Typography>
                </Box>
                {/* <Box>
                  <DropInput label="Edit" />
                </Box> */}
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Box display="flex" justifyContent="space-between">
                    <Typography
                      variant="body1"
                      component="p"
                      className={classes.fieldLabel}
                    >
                      FIRST NAME
                    </Typography>
                  </Box>
                  <Box>
                    <TextField
                      fullWidth={true}
                      className={classes.textFieldRoot}
                      variant="outlined"
                      InputProps={{
                        classes: { root: classes.textFieldStyles },
                        inputProps: { maxLength: 20 },
                      }}
                      value={firstName}
                      onChange={(e) => {
                        let val = e.target.value.replace(/[^a-zA-Z]/, "");
                        setFirstName(val);
                      }}
                      error={errorFields.firstname}
                      helperText={
                        errorFields.firstname ? "Please enter name" : null
                      }
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box display="flex" justifyContent="space-between">
                    <Typography
                      variant="body1"
                      component="p"
                      className={classes.fieldLabel}
                    >
                      LAST NAME
                    </Typography>
                  </Box>
                  <Box>
                    <TextField
                      fullWidth={true}
                      className={classes.textFieldRoot}
                      variant="outlined"
                      InputProps={{
                        classes: { root: classes.textFieldStyles },
                        inputProps: { maxLength: 20 },
                      }}
                      value={lastName}
                      onChange={(e) => {
                        let val = e.target.value.replace(/[^a-zA-Z]/, "");
                        setLastName(val);
                      }}
                      error={errorFields.lastname}
                      helperText={
                        errorFields.lastname ? "Please enter name" : null
                      }
                    />
                  </Box>
                </Grid>
              </Grid>
              {/*Address part*/}
              <Box display="flex" justifyContent="space-between">
                <Typography
                  variant="body1"
                  component="p"
                  className={classes.fieldLabel}
                >
                  STREET LINE
                </Typography>
              </Box>
              <Box>
                <TextField
                  fullWidth={true}
                  name="street1"
                  required
                  className={classes.textFieldRoot}
                  variant="outlined"
                  multiline
                  InputProps={{
                    classes: { root: classes.textFieldStyles },
                    inputProps: { maxLength: 100 },
                  }}
                  value={streetAddress1}
                  onChange={(e) => {
                    let val = e.target.value.replace(/[^a-zA-Z\d\-,\s]/, "");
                    setStreetAddress1(val);
                  }}
                  error={errorFields.st1}
                  helperText={errorFields.st1 ? "Please enter address" : null}
                />
              </Box>

              {/* <Box display="flex" justifyContent="space-between">
                <Typography
                  variant="body1"
                  component="p"
                  className={classes.fieldLabel}
                >
                  STREET LINE 2
                </Typography>
              </Box>
              <Box>
                <TextField
                  fullWidth={true}
                  name="street2"
                  required
                  className={classes.textFieldRoot}
                  variant="outlined"
                  InputProps={{
                    classes: { root: classes.textFieldStyles },
                    inputProps: { maxLength: 100 },
                  }}
                  value={streetAddress2}
                  onChange={(e) => {
                    let val = e.target.value.replace(/[^a-zA-Z\d\-,\s]/, "");
                    setStreetAddress2(val);
                  }}
                  error={errorFields.st2}
                  helperText={errorFields.st2 ? "Please enter address" : null}
                />
              </Box> */}
              <Box display="flex" justifyContent="space-between">
                <Typography
                  variant="body1"
                  component="p"
                  className={classes.fieldLabel}
                >
                  CITY
                </Typography>
              </Box>
              <Box>
                <TextField
                  fullWidth={true}
                  name="city"
                  required
                  className={classes.textFieldRoot}
                  variant="outlined"
                  InputProps={{
                    classes: { root: classes.textFieldStyles },
                    inputProps: { maxLength: 100 },
                  }}
                  value={city}
                  onChange={(e) => {
                    let val = e.target.value.replace(/[^a-zA-Z\-,\s]/, "");
                    setCity(val);
                  }}
                  error={errorFields.city}
                  helperText={errorFields.city ? "Please enter city" : null}
                />
              </Box>

              <Box>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="body1"
                        component="p"
                        className={classes.fieldLabel}
                      >
                        STATE
                      </Typography>
                    </Box>
                    <Box>
                      <TextField
                        fullWidth={true}
                        name="state"
                        required
                        className={classes.textFieldRoot}
                        variant="outlined"
                        InputProps={{
                          classes: { root: classes.textFieldStyles },
                          inputProps: { maxLength: 100 },
                        }}
                        value={state}
                        onChange={(e) => {
                          let val = e.target.value.replace(
                            /[^a-zA-Z\-,\s]/,
                            ""
                          );
                          setState(val);
                        }}
                        error={errorFields.state}
                        helperText={
                          errorFields.state ? "Please enter state" : null
                        }
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={6}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="body1"
                        component="p"
                        className={classes.fieldLabel}
                      >
                        ZIPCODE
                      </Typography>
                    </Box>
                    <Box>
                      <TextField
                        fullWidth={true}
                        name="zip"
                        required
                        className={classes.textFieldRoot}
                        variant="outlined"
                        InputProps={{
                          classes: { root: classes.textFieldStyles },
                          inputProps: { maxLength: 6 },
                        }}
                        value={zipcode}
                        onChange={(e) => {
                          let val = e.target.value.replace(/[^0-9]/, "");
                          setZipcode(val);
                        }}
                        error={errorFields.zip}
                        helperText={
                          errorFields.zip ? "Please enter zip code" : null
                        }
                      />
                    </Box>
                  </Grid>
                </Grid>
                {isBasicInfoValid ? null : (
                  <p style={{ color: "red", margin: 0, marginTop: "10px" }}>
                    Please make sure you have entered all the details correctly.
                  </p>
                )}
                <div style={{ textAlign: "right" }}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={() => {
                      setDoubleClick(true);
                      onBasicInfoSubmit();
                    }}
                    disabled={doubleClick}
                  >
                    Submit
                  </Button>
                </div>
              </Box>
            </div>
          )}

          {kycDetails.stepOneComplete &&
          kycDetails.stepTwoComplete &&
          kycDetails.stepThreeComplete &&
          kycDetails.stepFourComplete ? null : (
            <div
              className={classes.notice}
              style={{
                marginTop: "35px",
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              Please fill all the details, all details are mandatory for
              approving KYC
            </div>
          )}

          {/*Pan card part*/}
          {kycDetails.stepTwoComplete ? (
            kycDetails.documentNumberPrimary === "" ? (
              <div
                style={{
                  pointerEvents: step < 2 ? "none" : null,
                  opacity: step < 2 ? "0.4" : null,
                }}
              >
                <Box>
                  <Typography
                    variant="h4"
                    component="h4"
                    className={classes.stepHeading}
                    style={{ marginTop: "90px" }}
                  >
                    PAN Card
                  </Typography>
                  <Typography
                    variant="body1"
                    component="p"
                    gutterBottom
                    className={classes.stepSubHeading}
                  >
                    Enter your PAN card details below
                  </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between">
                  <Typography
                    variant="body1"
                    component="p"
                    className={classes.fieldLabel}
                  >
                    PAN CARD NUMBER
                  </Typography>
                </Box>
                <Box mb={4}>
                  <TextField
                    fullWidth={true}
                    name="panNumber"
                    required
                    className={classes.textFieldRoot}
                    variant="outlined"
                    InputProps={{
                      classes: { root: classes.textFieldStyles },
                      inputProps: { maxLength: 10 },
                    }}
                    value={panNum}
                    onChange={(e) => {
                      let val = e.target.value.replace(/[^a-zA-Z\d\s]/, "");
                      setPanNum(val);
                    }}
                    error={errorFields.panno}
                    helperText={
                      errorFields.panno ? "Please enter PAN number" : null
                    }
                  />
                </Box>
                <div style={{ textAlign: "right" }}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={() => {
                      setDoubleClick(true);
                      submitPANnum();
                    }}
                    disabled={doubleClick}
                  >
                    Submit
                  </Button>
                </div>
              </div>
            ) : (
              <div style={{ pointerEvents: "none", opacity: "0.4" }}>
                <Box>
                  <Typography
                    variant="h4"
                    component="h4"
                    className={classes.stepHeading}
                    style={{ marginTop: "90px" }}
                  >
                    PAN Card
                  </Typography>
                  <Typography
                    variant="body1"
                    component="p"
                    gutterBottom
                    className={classes.stepSubHeading}
                  >
                    Enter your PAN card details below
                  </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between">
                  <Typography
                    variant="body1"
                    component="p"
                    className={classes.fieldLabel}
                  >
                    PAN CARD NUMBER
                  </Typography>
                </Box>
                <Box mb={4}>
                  <TextField
                    fullWidth={true}
                    name="panNumber"
                    required
                    className={classes.textFieldRoot}
                    InputProps={{
                      classes: { root: classes.textFieldStyles },
                    }}
                    variant="outlined"
                    value={kycDetails.documentNumberPrimary}
                  />
                </Box>
              </div>
            )
          ) : (
            <div
              style={{
                pointerEvents: step < 2 ? "none" : null,
                opacity: step < 2 ? "0.4" : null,
              }}
            >
              <Box>
                <Typography
                  variant="h4"
                  component="h4"
                  className={classes.stepHeading}
                  style={{ marginTop: "90px" }}
                >
                  PAN Card
                </Typography>
                <Typography
                  variant="body1"
                  component="p"
                  gutterBottom
                  className={classes.stepSubHeading}
                >
                  Enter your PAN card details below
                </Typography>
                <Typography
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    marginTop: "15px",
                  }}
                >
                  How to upload your Aadhar and PAN card?
                </Typography>
                <ol style={{ color: theme.palette.text.primary, opacity: 0.6 }}>
                  <li>Place the card on a flat surface.</li>
                  <li>Donot hold the document in your hand.</li>
                  <li>Make sure the details are clearly visible.</li>
                  <li>
                    Finally drag and drop or upload the respective document.
                  </li>
                </ol>
              </Box>
              <Box display="flex" justifyContent="space-between">
                <Typography
                  variant="body1"
                  component="p"
                  className={classes.fieldLabel}
                >
                  PAN CARD NUMBER
                </Typography>
              </Box>
              <Box mb={4}>
                <TextField
                  fullWidth={true}
                  name="panNumber"
                  required
                  className={classes.textFieldRoot}
                  variant="outlined"
                  InputProps={{
                    classes: { root: classes.textFieldStyles },
                    inputProps: { maxLength: 10 },
                  }}
                  value={panNum}
                  onChange={(e) => {
                    let val = e.target.value.replace(/[^a-zA-Z\d\s]/, "");
                    setPanNum(val);
                  }}
                  error={errorFields.panno}
                  helperText={
                    errorFields.panno ? "Please enter PAN number" : null
                  }
                />
              </Box>

              <div style={{ maxWidth: "350px" }}>
                <DropInput
                  label="PAN card"
                  fluid
                  upload={(files) => {
                    setPanFront(files[0]);
                  }}
                />
              </div>

              <Box mt={2}>
                <Typography style={{ color: "#858585", fontSize: "14px" }}>
                  Image should be .jpg or .png and below 5mb
                </Typography>
              </Box>
              {errorFields.pancard ? (
                <p style={{ color: "red", margin: 0 }}>Please upload image</p>
              ) : null}
              <div style={{ textAlign: "right" }}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={() => {
                    setDoubleClick(true);
                    onPanSubmit();
                  }}
                  disabled={doubleClick}
                >
                  Submit
                </Button>
              </div>
            </div>
          )}

          {/*secondary identification part*/}
          {kycDetails.stepThreeComplete ? (
            <div style={{ pointerEvents: "none", opacity: "0.4" }}>
              <Box>
                <Typography
                  variant="h4"
                  component="h4"
                  className={classes.stepHeading}
                  style={{ marginTop: "90px" }}
                >
                  Secondary Identification
                </Typography>
                <Typography
                  variant="body1"
                  component="p"
                  gutterBottom
                  className={classes.stepSubHeading}
                >
                  Enter your secondary identification details below
                </Typography>
              </Box>
              <Box
                display="flex"
                justifyContent="space-between"
                style={{ marginTop: "20px" }}
              >
                <Typography
                  variant="body1"
                  component="p"
                  className={classes.fieldLabel}
                >
                  DOCUMENT NUMBER
                </Typography>
              </Box>
              <Box mb={4}>
                <TextField
                  fullWidth={true}
                  name="secondaryId"
                  required
                  className={classes.textFieldRoot}
                  InputProps={{
                    classes: { root: classes.textFieldStyles },
                  }}
                  variant="outlined"
                  value={kycDetails.documentNumberSecondary}
                />
              </Box>
            </div>
          ) : (
            <div
              style={{
                pointerEvents: step < 2 ? "none" : null,
                opacity: step < 2 ? "0.4" : null,
              }}
            >
              <Box>
                <Typography
                  variant="h4"
                  component="h4"
                  className={classes.stepHeading}
                  style={{ marginTop: "90px" }}
                >
                  Secondary Identification
                </Typography>
                <Typography
                  variant="body1"
                  component="p"
                  gutterBottom
                  className={classes.stepSubHeading}
                >
                  Enter your secondary identification details below
                </Typography>
              </Box>

              <Typography
                variant="body1"
                component="p"
                className={classes.fieldLabel}
                style={{ marginTop: "40px" }}
              >
                SELECT TYPE OF SECONDARY IDENTIFICATION
              </Typography>

              <FormControl variant="outlined" className={classes.formControl}>
                <Select
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    getContentAnchorEl: null,
                  }}
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={cardType}
                  onChange={(event) => {
                    setCardType(event.target.value);
                    setSecondaryNum("");
                  }}
                >
                  <MenuItem value="aadhar card">Aadhar Card</MenuItem>
                  <MenuItem value="driving license">Driving License</MenuItem>
                  <MenuItem value="voter card">Voter Card</MenuItem>
                  <MenuItem value="passport">Passport</MenuItem>
                </Select>
              </FormControl>

              <Box
                display="flex"
                justifyContent="space-between"
                style={{ marginTop: "20px" }}
              >
                <Typography
                  variant="body1"
                  component="p"
                  className={classes.fieldLabel}
                >
                  {cardType} NUMBER
                </Typography>
              </Box>
              <Box mb={4}>
                <TextField
                  fullWidth={true}
                  name="secondaryId"
                  required
                  className={classes.textFieldRoot}
                  variant="outlined"
                  InputProps={{
                    classes: { root: classes.textFieldStyles },
                    inputProps: { maxLength: 15 },
                  }}
                  value={secondaryNum}
                  onChange={(e) => {
                    let val;
                    if (cardType === "aadhar card") {
                      // numeric only
                      val = e.target.value.replace(/[^0-9]$/, "");
                    } else {
                      // alphanumeric
                      val = e.target.value.replace(/[^a-zA-Z\d\-\s]/, "");
                    }
                    setSecondaryNum(val);
                  }}
                  error={errorFields.secno}
                  helperText={errorFields.secno ? "Please enter number" : null}
                />
              </Box>

              <Box>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Box mr={8}>
                      <DropInput
                        label={`${cardType} front`}
                        fluid
                        upload={(files) => {
                          setSecondaryFront(files[0]);
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Box mr={8}>
                      <DropInput
                        label={`${cardType} back`}
                        fluid
                        upload={(files) => {
                          setSecondaryBack(files[0]);
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
              {errorFields.seccardf || errorFields.seccardb ? (
                <p style={{ color: "red", margin: 0, marginTop: "10px" }}>
                  Please upload all documents
                </p>
              ) : null}
              <div style={{ textAlign: "right" }}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={() => {
                    setDoubleClick(true);
                    onSecondaryDocSubmit();
                  }}
                  disabled={doubleClick}
                >
                  Submit
                </Button>
              </div>
            </div>
          )}

          {/*Video selfie*/}
          <div
            style={{
              pointerEvents: step < 2 ? "none" : null,
              opacity: step < 2 ? "0.4" : null,
              marginBottom: "40px",
            }}
          >
            {kycDetails.stepFourComplete ? (
              <>
                <Box mt={10}>
                  <Typography
                    variant="h4"
                    component="h4"
                    className={classes.stepHeading}
                  >
                    Video selfie
                  </Typography>
                  <Typography
                    variant="body1"
                    component="p"
                    gutterBottom
                    className={classes.stepSubHeading}
                  >
                    Record a short video of yourself reading out the following
                    numbers and declaration sentence.
                  </Typography>
                  <p>Video uploaded.</p>
                </Box>
              </>
            ) : (
              <div style={{ marginTop: "80px" }}>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <Box>
                    <Typography
                      variant="h4"
                      component="h4"
                      className={classes.stepHeading}
                    >
                      Video selfie
                    </Typography>
                    <Typography
                      variant="body1"
                      component="p"
                      gutterBottom
                      className={classes.stepSubHeading}
                    >
                      Record a short video of yourself reading out the following
                      numbers and declaration sentence
                    </Typography>
                  </Box>
                  <Hidden smDown>
                    {kycDetails.phonenumber ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "14px",
                          marginLeft: "auto",
                        }}
                      >
                        <Typography
                          variant="body1"
                          component="p"
                          gutterBottom
                          className={classes.stepSubHeading}
                        >
                          Continue filling this form on Mobile?
                        </Typography>
                        <Button
                          variant="contained"
                          color="primary"
                          style={{ color: "white", fontWeight: "bold" }}
                          onClick={() => {
                            setDoubleClick(true);
                            sendSMS();
                          }}
                        >
                          Get the link in SMS
                        </Button>
                      </div>
                    ) : null}
                  </Hidden>
                </div>
                {/* <VideoRec
                  name={`${kycDetails.firstName} ${kycDetails.lastName}`}
                  vidDone={(flag) => {
                    if (flag) {
                      setStep(5);
                    }
                  }}
                /> */}
                <ReactVideoRec
                  name={`${kycDetails.firstName} ${kycDetails.lastName}`}
                  vidDone={(flag) => {
                    if (flag) {
                      setStep(5);
                    }
                  }}
                />
              </div>
            )}
          </div>
        </Grid>
      </Grid>

      <Backdrop
        className={classes.backdrop}
        open={showMilestone ? false : true}
      >
        {/* <CircularProgress color="primary" /> */}
        <img src={loaderGif} alt="loading..." />
      </Backdrop>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    // marginTop: theme.spacing(10),
    // marginLeft: theme.spacing(10),
    // alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      // width: '90%',
      marginTop: "20px",
      maxWidth: "450px",
      // minWidth: "450px",
      // marginLeft: "25px",
      // marginRight: "25px",
    },
    [theme.breakpoints.up("md")]: {
      // width: "50%",
      marginTop: "50px",
    },
    // margin: "auto",
    marginBottom: "80px",
  },
  paddedContainer: {
    padding: "40px",
    background: theme.palette.type === "dark" ? "#151827" : "white",
  },
  topHeading: {
    color: "#3AC4AB",
    fontWeight: "bold",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.3rem",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "2rem",
    },
  },
  stepHeading: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.3rem",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "1.5625rem",
    },
  },
  stepSubHeading: {
    color: theme.palette.text.primary,
    opacity: 0.6,
    letterSpacing: 0.3,
  },
  twoFactorContainer: {
    border: `1px solid #3AC4AB`,
    backgroundColor: "rgba(86,195,164,0.1)",
    padding: "6px 12px",
    borderRadius: "2px",
  },
  labelText: {
    fontWeight: "bold",
    color: theme.palette.text.primary,
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.8rem",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "1rem",
    },
  },
  activeTFLabelStyles: {
    color: "#3AC4AB",
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.6rem",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "12px",
    },
  },
  inactiveTFLabelStyles: {
    color: theme.palette.text.primary,
    opacity: 0.5,
    // [theme.breakpoints.down('xs')]: {
    //   fontSize: '0.6rem',
    // },
    // [theme.breakpoints.up('sm')]: {
    //   fontSize: "12px"
    // },
    fontSize: "5px",
  },
  textFieldRoot: {
    "& > p": {
      color: theme.palette.text.primary,
      opacity: 0.5,
      fontSize: "13px",
      lineHeight: "16px",
    },
  },
  textFieldStyles: {
    border: `1px solid ${theme.palette.text.primary}40`,
    borderRadius: 3,
    "&::before": {
      display: "none",
    },
    "& input": {
      padding: "12px 14px",
      color: theme.palette.text.primary,
      fontWeight: "bold",
      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: 0,
      },
    },
  },
  fieldLabel: {
    fontWeight: "bold",
    color: theme.palette.text.primary,
    opacity: "0.5",
    textTransform: "uppercase",
    marginTop: "17px",
    paddingBottom: "0px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.8rem",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "1rem",
    },
  },
  formControl: {
    margin: 0,
    fullWidth: true,
    display: "flex",
    wrap: "nowrap",
  },
  paddedBox: {
    minWidth: "70%",
    margin: "0 auto",
    marginTop: "50px",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    color: "#fff",
    fontWeight: "600",
    width: "150px",
  },
  link: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
    margin: 0,
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  notice: {
    border: `1px solid #3AC4AB`,
    backgroundColor: "rgba(86,195,164,0.1)",
    padding: "15px",
    // marginTop: "20px",
    // marginLeft: "15px",
    // marginRight: "15px",
    borderRadius: "8px",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));
